/* tslint:disable */
/* eslint-disable */
/**
 * Bookings API
 * Bookings API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateReservationRequest,
  CreateReservationRequestReservation,
  GetDayAvailability200ResponseValueInner,
  GetLocations200ResponseInner,
} from '../models/index';
import {
    CreateReservationRequestFromJSON,
    CreateReservationRequestToJSON,
    CreateReservationRequestReservationFromJSON,
    CreateReservationRequestReservationToJSON,
    GetDayAvailability200ResponseValueInnerFromJSON,
    GetDayAvailability200ResponseValueInnerToJSON,
    GetLocations200ResponseInnerFromJSON,
    GetLocations200ResponseInnerToJSON,
} from '../models/index';

export interface CancelReservationRequest {
    reservationId: string;
}

export interface CreateReservationOperationRequest {
    createReservationRequest: CreateReservationRequest;
}

export interface GetDayAvailabilityRequest {
    partySize: number;
    date: string;
    ignoreReservationId?: string;
}

export interface GetMonthAvailabilityRequest {
    partySize: number;
    month: string;
    ignoreReservationId?: string;
}

export interface UpdateReservationRequest {
    reservationId: string;
    createReservationRequestReservation: CreateReservationRequestReservation;
}

/**
 * 
 */
export class BookingsApi extends runtime.BaseAPI {

    /**
     */
    async cancelReservationRaw(requestParameters: CancelReservationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['reservationId'] == null) {
            throw new runtime.RequiredError(
                'reservationId',
                'Required parameter "reservationId" was null or undefined when calling cancelReservation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reservations/{reservationId}`.replace(`{${"reservationId"}}`, encodeURIComponent(String(requestParameters['reservationId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async cancelReservation(requestParameters: CancelReservationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.cancelReservationRaw(requestParameters, initOverrides);
    }

    /**
     */
    async createReservationRaw(requestParameters: CreateReservationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['createReservationRequest'] == null) {
            throw new runtime.RequiredError(
                'createReservationRequest',
                'Required parameter "createReservationRequest" was null or undefined when calling createReservation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/reservations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateReservationRequestToJSON(requestParameters['createReservationRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async createReservation(requestParameters: CreateReservationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createReservationRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getConfigRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/availability/config`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async getConfig(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getConfigRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getDayAvailabilityRaw(requestParameters: GetDayAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: Array<GetDayAvailability200ResponseValueInner>; }>> {
        if (requestParameters['partySize'] == null) {
            throw new runtime.RequiredError(
                'partySize',
                'Required parameter "partySize" was null or undefined when calling getDayAvailability().'
            );
        }

        if (requestParameters['date'] == null) {
            throw new runtime.RequiredError(
                'date',
                'Required parameter "date" was null or undefined when calling getDayAvailability().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['partySize'] != null) {
            queryParameters['partySize'] = requestParameters['partySize'];
        }

        if (requestParameters['date'] != null) {
            queryParameters['date'] = requestParameters['date'];
        }

        if (requestParameters['ignoreReservationId'] != null) {
            queryParameters['ignoreReservationId'] = requestParameters['ignoreReservationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/availability/day`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getDayAvailability(requestParameters: GetDayAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: Array<GetDayAvailability200ResponseValueInner>; }> {
        const response = await this.getDayAvailabilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getLocationsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetLocations200ResponseInner>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/availability/locations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetLocations200ResponseInnerFromJSON));
    }

    /**
     */
    async getLocations(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetLocations200ResponseInner>> {
        const response = await this.getLocationsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getMonthAvailabilityRaw(requestParameters: GetMonthAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['partySize'] == null) {
            throw new runtime.RequiredError(
                'partySize',
                'Required parameter "partySize" was null or undefined when calling getMonthAvailability().'
            );
        }

        if (requestParameters['month'] == null) {
            throw new runtime.RequiredError(
                'month',
                'Required parameter "month" was null or undefined when calling getMonthAvailability().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['partySize'] != null) {
            queryParameters['partySize'] = requestParameters['partySize'];
        }

        if (requestParameters['month'] != null) {
            queryParameters['month'] = requestParameters['month'];
        }

        if (requestParameters['ignoreReservationId'] != null) {
            queryParameters['ignoreReservationId'] = requestParameters['ignoreReservationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/availability/month`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getMonthAvailability(requestParameters: GetMonthAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getMonthAvailabilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateReservationRaw(requestParameters: UpdateReservationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['reservationId'] == null) {
            throw new runtime.RequiredError(
                'reservationId',
                'Required parameter "reservationId" was null or undefined when calling updateReservation().'
            );
        }

        if (requestParameters['createReservationRequestReservation'] == null) {
            throw new runtime.RequiredError(
                'createReservationRequestReservation',
                'Required parameter "createReservationRequestReservation" was null or undefined when calling updateReservation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/reservations/{reservationId}`.replace(`{${"reservationId"}}`, encodeURIComponent(String(requestParameters['reservationId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateReservationRequestReservationToJSON(requestParameters['createReservationRequestReservation']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateReservation(requestParameters: UpdateReservationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateReservationRaw(requestParameters, initOverrides);
    }

}
